import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import {
  getMinPenyakit,
  penyakitSelector,
} from "../../features/master/penyakit/penyakitSlice";
import { cutiSelector } from "../../features/master/cuti/masterCutiSlice";

import { useDispatch, useSelector } from "react-redux";
import NumberFormat from "react-number-format";

// import Select from "react-select";
import {
  GetKaryawanMinV2,
  karyawanSelector,
} from "../../features/hrd/karyawan/karyawanSlice";
import {
  getMinLokasiTugasSelector,
  lokasiTugasSelector,
} from "../../features/master/lokasi-tugas/lokasiTugasSlice";
import { KaryawanSelectorCutiBuilder } from "../../features/hrd/karyawan/KaryawanSelector";
import {
  getMinSubGroupAccountData,
  subGroupAccountSelector,
} from "../../features/master/sub-group-account/subGroupAccountSlice";
import { useMutation } from "@tanstack/react-query";
import { fetchGet, fetchPost } from "../../fetchers";

import Select from "react-select";
// import { BiChevronDown, BiWindowClose } from "react-icons/bi";
// import clsx from 'clsx';

export function HrdInputGenerator(props) {
  const dispatch = useDispatch();
  const karyawan = useSelector(karyawanSelector);
  const region = useSelector(lokasiTugasSelector);
  const penyakit = useSelector(penyakitSelector);
  const cuti = useSelector(cutiSelector);
  const COA = useSelector(subGroupAccountSelector);
  const [pRListComparison, setPRListComparison] = useState(0);
  const [PRListNominal, setPRListNominal] = useState(0);
  // Biaya Lain-lain PC yang ikut di Termin 1 (untuk keterangan di bawah nominal termin).
  const [terminBiayaLain, setTerminBiayaLain] = useState({ nominal: 0, ket: "" });
  const removeDuplicateValues = (arr) => {
    let seenValues = {};

    // Loop through the array of objects
    for (let i = 0; i < arr.length; i++) {
      const obj = arr[i];

      // If the value has already been seen, remove the object from the array
      if (seenValues[obj.value]) {
        arr.splice(i, 1);
        i--;
      }
      // Otherwise, mark the value as seen and continue
      else {
        seenValues[obj.value] = true;
      }
    }

    // Return the modified array
    return arr;
  };

  const Status = [
    { label: "Aktif", value: "1" },
    { label: "Non-Aktif", value: "2" },
  ];
  const PerkiraanHarga = [
    { label: "> 5Jt", value: "5100000" },
    { label: "< 5Jt", value: "4900000" },
  ];
  const Sifat = [
    { label: "Urgent", value: "Urgent" },
    { label: "Normal", value: "Normal" },
    { label: "Priority", value: "Priority" },
  ];

  const TipePR = [
    { label: "Barang", value: "Barang" },
    { label: "Jasa", value: "Jasa" },
  ];
  const JenisBarangSatu = [
    { label: "All", value: "" },
    { label: "Material", value: "Material" },
    { label: "Logistik", value: "Logistik" },
  ];
  // const JenisPetugas = [
  //   { label: "Operator", value: "Operator" },
  //   { label: "Helper", value: "Helper" },
  //   { label: "Driver", value: "Driver" },
  // ];
  const SatuanKendaraan = [
    { label: "Rit", value: "Rit" },
    { label: "HM", value: "HM" },
    { label: "KM", value: "KM" },
  ];

  const JenisTransaksiKasBank = [
    { label: "Pengeluaran", value: "Pengeluaran" },
    { label: "Penerimaan", value: "Penerimaan" },
    { label: "Downpayment PO", value: "Downpayment PO" },
  ];

  // Sama seperti JenisTransaksiKasBank, tapi tanpa opsi "Penerimaan" —
  // dipakai khusus di form input (form-kas-bank) agar opsi itu tak bisa
  // dipilih lagi. Jangan pakai di approval/detail: dokumen lama ber-
  // JenisTransaksi "Penerimaan" perlu tetap tampil lewat array penuh di atas.
  const JenisTransaksiKasBankInput = JenisTransaksiKasBank.filter(
    ({ value }) => value !== "Penerimaan"
  );

  const JenisTermin = [
    { label: "Termin 1", value: "Termin1" },
    { label: "Termin 2", value: "Termin2" },
    { label: "Termin 3", value: "Termin3" },
  ];

  const JenisPenerimaan = [
    { label: "Kas", value: "Kas" },
    { label: "Bank IDR", value: "Bank IDR" },
    { label: "Bank USD", value: "Bank USD" },
  ];

  const StatusReportPO = [
    { label: "Approved", value: "1" },
    { label: "Rejected", value: "2" },
  ];

  const JenisBarang = [
    { label: "Material", value: "Material" },
    { label: "Logistik", value: "Logistik" },
  ];

  const Menu = [
    { label: "PurchaseOrderJasa", value: "PurchaseOrderJasa" },
    { label: "GoodsAcceptanceUser", value: "GoodsAcceptanceUser" },
    { label: "MSR", value: "MSR" },
    { label: "MSR Non Stock", value: "MSRNonStock" },
    { label: "MSR Non Stock > 5JT", value: "MSRNonStockBesar" },
    { label: "Price Comparison", value: "PriceComparation" },
    { label: "Price Comparison > 10JT", value: "PriceComparationBesar" },

    // ── Grup approval Kas Bank Non-PO ────────────────────────────────────
    // `value` di sini HARUS sama persis dengan petaGrupApprovalNonPO di
    // backend/models/accounting/cashjournal.go — nama grup hidup di dua tempat,
    // dan backend mencocokkannya sebagai string mentah. Salah satu huruf saja
    // membuat grupnya tak pernah ditemukan; sistem TIDAK error, ia hanya diam-diam
    // memakai grup lama (fallback), jadi kekeliruan begini sulit terlihat.
    //
    // Grup lama melayani SEMUA dokumen Non-PO — labelnya dulu tertulis "Uang Muka"
    // padahal Pengeluaran & Penerimaan pun lewat situ. Kini ia berperan sebagai
    // penadah: kombinasi yang grup khususnya belum dibuat tetap memakainya.
    {
      label: "Pembayaran Non-PO HO (Pengeluaran)",
      value: "PermohonanPembayaranNonPOHO",
    },
    {
      label: "Pembayaran Uang Muka HO",
      value: "PermohonanPembayaranUangMukaHO",
    },
    {
      label: "Pembayaran Non-PO SO (Pengeluaran)",
      value: "PermohonanPembayaranNonPOSO",
    },
    {
      label: "Pembayaran Uang Muka SO",
      value: "PermohonanPembayaranUangMukaSO",
    },
    {
      label: "Pembayaran Non-PO (lama — semua unit & jenis)",
      value: "PermohonanPembayaranNonPO",
    },
    { label: "Jurnal", value: "Jurnal" },
    { label: "Petty Cash HO", value: "Petty Cash HO" },
    { label: "Petty Cash SO", value: "Petty Cash SO" },
    { label: "Penerimaan Kas Ho", value: "Penerimaan Kas Ho" },
    { label: "Penerimaan Kas SO", value: "Penerimaan Kas SO" },
    { label: "Penerimaan Dana", value: "Penerimaan Dana" },
    { label: "Penerimaan Barang", value: "Penerimaan Barang" },
    { label: "Pengeluaran Barang", value: "Pengeluaran Barang" },
    { label: "Permohonan Pembayaran AP", value: "PermohonanPembayaranAP" },
    { label: "Job Request", value: "JobRequest" },
    // `value` dipakai mentah sebagai MasterApproval."Group" dan dicocokkan
    // backend sebagai string — samakan persis dengan resolver approval QO.
    // Pola sama dengan JobRequest: Bagian '-' (berlaku semua bagian).
    { label: "Quotation", value: "Quotation" },
    { label: "Kendaraan", value: "Kendaraan" },
    { label: "Lembur", value: "Lembur" },
    // Group="Cuti" / "Sakit" — rantai approval sendiri (dipisah dari Lembur 2026-10-13),
    // dicek per Bagian karyawan di approval_cuti.go / approval_sakit.go.
    { label: "Cuti", value: "Cuti" },
    { label: "Sakit", value: "Sakit" },
    // Group="PerjalananDinas" — rantai dari Struktur Organisasi (approval_perjalanandinas.go);
    // isi baris Bagian "Tanpa Bagian" dengan verifikator HR & Finance.
    { label: "Perjalanan Dinas - Pengajuan", value: "PerjalananDinas" },
    // Group="PerjalananDinasLPD" — SELURUH rantai Pertanggungjawaban (tanpa atasan struktur):
    // isi baris Bagian "Tanpa Bagian" berurutan HR → Finance → Accounting.
    { label: "Perjalanan Dinas - Pertanggungjawaban", value: "PerjalananDinasLPD" },
    // Group="Promosi" — dicek MasterApproval per-Bagian di approval_promosi.go
    // (pilot unifikasi approval, lihat memori ranji-hr-audit-fase1-3). Tanpa
    // entri ini HRD tak bisa mengisi approver Promosi lewat Setup > Approval.
    { label: "Promosi", value: "Promosi" },
    // Group="KontrakKerja" — Fase 4, modul baru dgn pola sama Promosi.
    { label: "Kontrak Kerja", value: "KontrakKerja" },
  ];

  const LokasiGudang = [
    { label: "Gudang Material", value: "Gudang Material" },
    { label: "Gudang Logistik", value: "Gudang Logistik" },
  ];

  const kelompok = useMutation((formData) => fetchGet("Master/Kelompok/min"));
  const detailAccount = useMutation((formData) =>
    fetchGet("GetMinMasterDetailAccountV2")
  );
  const satuan = useMutation((formData) => fetchGet("getMinMasterSatuan"));
  const bisnisUnit = useMutation((formData) =>
    fetchGet("getMinMasterBisnisUnit")
  );
  const barang = useMutation((formData) => fetchGet("Master/Barang/min"));
  const baranggoods = useMutation((formData) =>
    fetchGet("Procurement/GoodsStockMin")
  );
  const userPC = useMutation((formData) => fetchGet("Master/UserPC/min"));
  const karyawanPemohon = useMutation(() => fetchGet("getKaryawanPemohon"));
  const jabatan = useMutation((formData) => fetchGet("getMinMasterJabatanV2"));
  const bagian = useMutation((formData) => fetchGet("getMinMasterBagianV2"));
  const po = useMutation((formData) =>
    fetchGet("Procurement/PurchaseOrder/min", formData)
  );
  const activity = useMutation((formData) =>
    fetchGet("Master/Activity/min", formData)
  );
  const JenisPetugas = useMutation((formData) =>
    fetchGet("getMasterJenisPetugas/min", formData)
  );
  const GeneralServiceUnit = useMutation((formData) =>
    fetchGet("Master/GeneralServiceUnit/getMinV2", formData)
  );
  const kota = useMutation((formData) => fetchGet("Master/Kota/min", formData));
  const provinsi = useMutation((formData) =>
    fetchGet("getMinProvinsi", formData)
  );
  const negara = useMutation((formData) =>
    fetchGet("Master/Negara/min", formData)
  );
  const mainAccount = useMutation((formData) =>
    fetchPost("getMinMasterMainAccountv2", formData)
  );
  const subAccount = useMutation((formData) =>
    fetchPost("getMinMasterSubAccountv2", formData)
  );
  const KelompokKegiatan = useMutation((formData) =>
    fetchGet("getMinMasterKelompokKegiatan", formData)
  );
  const Desa = useMutation((formData) =>
    fetchGet("Master/Desa/getMin", formData)
  );

  const GetGoodsAcceptancePembayaran = useMutation((formData) =>
    fetchGet(
      "Procurement/GoodsAcceptance/all/GetGoodsAcceptancePembayaran",
      formData
    )
  );
  useEffect(() => {
    if (props.type === "Termin") {
      // priceComparison.mutate(param.state.PurchaseRequisitionID);
      if (props.priceComparison.isSuccess) {
        const tempArray = props.priceComparison.data.data;
        if (tempArray != null) {
          // Dulu SELALU memakai tempArray[0] (entri PRComparison PERTAMA yang
          // ditemukan untuk PR ini, urutan apa adanya dari query -- bukan
          // supplier yang benar-benar dipilih/jadi PO) dan TANPA memfilter
          // PilihanBeli, sehingga item yang dibandingkan tapi TIDAK dibeli --
          // atau yang justru milik PO LAIN dari PR yang sama (satu PR bisa
          // melahirkan banyak PO dari supplier/PRComparisonID berbeda) --
          // ikut terjumlah. Insiden nyata: approval termin PO1623 (Starlink,
          // seharusnya Rp799.999) menampilkan Rp9.018.861 -- itu total PO1622
          // (Telkom+Astinet), PRComparisonID lain dari PR yang sama, yang
          // kebetulan ada di tempArray[0].
          //
          // Fix: kalau pemanggil sudah tahu PRComparisonID spesifik (PO sudah
          // ada/sedang dibuat dari satu supplier tertentu -- lihat prop
          // `prComparisonID` di insert-purchase-order.js &
          // approval-purchase-order.js), pakai HANYA entri itu. Kalau belum
          // ada keputusan per-PO sama sekali (tahap Purchase Requisition --
          // allocation/preview/approval/kirim, sebelum PR dipecah jadi PO),
          // jumlahkan PilihanBeli=true di SELURUH entri PR -- itulah yang
          // benar-benar akan dibeli, terlepas nanti pecah jadi berapa PO.
          const relevantEntries = props.prComparisonID
            ? tempArray.filter(
                (entry) => entry.PRComparisonID === props.prComparisonID
              )
            : tempArray;

          var total1 = 0;
          relevantEntries.forEach((entry) => {
            (entry.PRListComparison || []).forEach((item) => {
              if (item.PilihanBeli) {
                total1 += parseFloat(item.Harga) * parseFloat(item.Qty);
              }
            });
          });

          const persent = props.value[props.name];
          // Biaya Lain-lain PC (di luar biaya utama, tak kena pajak) seluruhnya ikut
          // TERMIN 1 — keputusan user 2026-10-14. Hanya supplier yang punya item terpilih.
          let biayaLainTermin = 0;
          const ketBiayaLain = [];
          if (props.name === "Termin1") {
            relevantEntries.forEach((entry) => {
              const adaTerpilih = (entry.PRListComparison || []).some((item) => item.PilihanBeli);
              const bl = parseFloat(entry.BiayaLain || 0) || 0;
              if (adaTerpilih && bl > 0) {
                biayaLainTermin += bl;
                if (entry.KeteranganBiayaLain) ketBiayaLain.push(entry.KeteranganBiayaLain);
              }
            });
          }
          setTerminBiayaLain({ nominal: biayaLainTermin, ket: ketBiayaLain.join(", ") });
          setPRListNominal(total1 * (persent / 100) + biayaLainTermin);
        }
      }
    }
  }, [props.priceComparison, props.prComparisonID]);

  useEffect(() => {
    if (props.type === "penyakit") {
      dispatch(getMinPenyakit({ search: "" }));
    } else if (props.type === "karyawan") {
      dispatch(GetKaryawanMinV2({ search: "" }));
    } else if (props.type === "region") {
      dispatch(getMinLokasiTugasSelector({ search: "" }));
    } else if (props.type === "COA") {
      dispatch(getMinSubGroupAccountData({ search: "" }));
    } else if (props.type === "KelompokKegiatan") {
      KelompokKegiatan.mutate();
    } else if (props.type === "Kelompok") {
      kelompok.mutate();
      if (props.bagianID) {
        barang.mutate();
      }
    } else if (props.type === "DetailAccount" || props.type === "LawanDetailAccount" || props.type === "LawanDetailAccountBeban") {
      detailAccount.mutate();
    } else if (props.type === "Desa") {
      Desa.mutate();
    } else if (props.type === "BisnisUnit") {
      bisnisUnit.mutate();
    } else if (props.type === "Satuan") {
      satuan.mutate();
    } else if (props.type === "Barang") {
      barang.mutate();
    } else if (props.type === "BarangGoods") {
      baranggoods.mutate();
    } else if (props.type === "BarangAgregate") {
      barang.mutate();
      baranggoods.mutate();
    } else if (props.type === "KaryawanPemohon") {
      karyawanPemohon.mutate();
    } else if (props.type === "userPC") {
      userPC.mutate();
    } else if (props.type === "Jabatan") {
      jabatan.mutate();
    } else if (props.type === "Bagian") {
      bagian.mutate();
    } else if (props.type === "Bagianv2") {
      bagian.mutate();
    } else if (props.type === "Bagianv3") {
      bagian.mutate();
    } else if (props.type === "BagianKodeJenis") {
      bagian.mutate();
    } else if (props.type === "PO") {
      po.mutate();
    } else if (props.type === "activity") {
      activity.mutate();
    } else if (props.type === "JenisPetugas") {
      JenisPetugas.mutate();
    } else if (props.type === "GeneralServiceUnit") {
      GeneralServiceUnit.mutate();
    } else if (props.type === "Kota") {
      kota.mutate();
    } else if (props.type === "Provinsi") {
      provinsi.mutate();
    } else if (props.type === "Negara") {
      negara.mutate();
    } else if (props.type === "DetailPembayaran") {
      detailAccount.mutate();
    } else if (props.type === "DetailAccountWithBody") {
      detailAccount.mutate();
    } else if (props.type === "GetGoodsAcceptancePembayaran") {
      GetGoodsAcceptancePembayaran.mutate();
    } else if (props.type === "karyawanApproval") {
      dispatch(GetKaryawanMinV2({ search: "" }));
    } else if (props.type === "mainAccount") {
      mainAccount.mutate();
    } else if (props.type === "subAccount") {
      subAccount.mutate({ MainAccountID: props.value["mainAccount"] });
    }
    // Kelompok disaring per Bagian, tapi komponen sudah terpasang sebelum Bagian
    // dipilih (form MSR): efek harus diulang saat bagianID berubah, kalau tidak data
    // barang untuk penyaring tak pernah dimuat dan semua kategori tampil.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.type === "Kelompok" ? props.bagianID : null]);

  const yesNot = [
    { label: "Iya", value: "true" },
    { label: "Tidak", value: "false" },
  ];
  const MemoStatus = [
    { label: "Open", value: "true" },
    { label: "Close", value: "false" },
  ];

  const onClickJenisTermin = (e) => {
    console.log(e);
  };

  const renderSwitch = () => {
    let value = "";
    if (props.type == "Termin") {
      if (props.value[props.name] !== undefined) {
        value = props.value[props.name];
      } else {
        value = props.value;
      }
    } else {
      if (props.value[props.name] !== undefined) {
        value = props.value[props.name];
      }
    }
    switch (props.type) {
      case "text":
        return (
          <>
            <input
              value={value}
              onChange={props.onChange}
              name={props.name}
              disabled={props.disabled}
              className={
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              type="text"
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "dateLock":
        return (
          <>
            <input
              value={new Date(value).toDateString()}
              onChange={props.onChange}
              name={props.name}
              disabled={props.disabled}
              className={
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              type="text"
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "number":
        return (
          <>
            <input
              onWheel={(event) => event.currentTarget.blur()}
              value={value}
              onChange={props.onChange}
              name={props.name}
              disabled={props.disabled}
              className={
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              type="number"
              step="any"
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "numberView": {
        // Tampilan read-only angka terformat (pemisah ribuan id-ID, tanpa desimal)
        // agar konsisten dgn kolom "Numbers" di tabel. DB menyimpan mis. "10000000.00";
        // input type="number" menampilkannya mentah — pakai ini utk field read-only.
        const raw = props.value[props.name];
        const num = parseFloat(raw);
        const display = isNaN(num)
          ? ""
          : num.toLocaleString("id-ID", { maximumFractionDigits: 0 });
        return (
          <input
            value={display}
            readOnly
            disabled
            name={props.name}
            className="appearance-none block w-full text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-gray-100 border-gray-500 cursor-not-allowed"
          />
        );
      }
      case "numberFormat":
        return (
          <>
            <input
              value={value}
              onChange={props.onChange}
              name={props.name}
              disabled={props.disabled}
              className={
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              }
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "numberFormatSatu":
        return (
          <>
            <NumberFormat
              thousandSeparator={true}
              onValueChange={(values, sourceInfo) => {
                // react-number-format fires onValueChange on ANY value change,
                // including a programmatic `value` prop update (e.g. an
                // auto-computed, disabled total field) — not just user typing.
                // sourceInfo.event only exists for real user input; forwarding
                // it unconditionally crashes event-based handlers (changeHandler
                // etc.) that assume `event.target` exists.
                if (!sourceInfo?.event) return;
                props.onChange(values, sourceInfo);
              }}
              name={props.name}
              value={value}
              disabled={props.disabled}
              className={
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              // isAllowed={(values) => {
              //   const { floatValue } = values;
              //   return floatValue >= 5 && floatValue <= 10000;
              // }}
            />
          </>
          // <>
          //   <input
          //     value={value}
          //     onChange={props.onChange}
          //     name={props.name}
          //     disabled={props.disabled}
          //     className={
          //       props.errors[props.name]
          //         ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
          //         : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
          //     }
          //   />
          //   {(props.touched[props.name] || props.buttonTouched) &&
          //     props.touched[props.name] && (
          //       <p className="text-red-500 text-xs italic">
          //         {props.errors[props.name]}
          //       </p>
          //     )}
          // </>
        );
        break;
      case "dateOnly":
        return (
          <>
            {/* Prop react-datepicker untuk mengunci input adalah `disabled`, bukan
                `isDisabled` (itu metode internal library, tak pernah dibaca dari props).
                Selama salah nama, `disabled={true}` pada 11 halaman baca-saja/approval
                TIDAK berefek dan tanggalnya masih bisa diubah lalu ikut terkirim. */}
            <DatePicker
              utcOffset={0}
              disabled={props.disabled}
              dateFormat="dd/MMMM/yyyy"
              timeFormat={"dd/MMMM/yyyy"}
              selected={new Date(value)}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              onChange={(text) => props.onChange(text, props.name)}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "date":
        return (
          <>
            <DatePicker
              utcOffset={0}
              showTimeInput
              showTimeSelect
              dateFormat="dd/MMMM/yyyy HH:mm"
              timeFormat={"dd/MMMM/yyyy HH:mm"}
              selected={new Date(value)}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              onChange={(text) => props.onChange(text, props.name)}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "time":
        let time = new Date();
        if (value !== "") {
          try {
            time = new Date(value);
          } catch (e) {
            console.log(value);
          }
        }
        return (
          <>
            <DatePicker
              utcOffset={0}
              showTimeSelect
              showTimeSelectOnly
              dateFormat="HH:mm"
              timeFormat={"HH:mm"}
              selected={time}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              onChange={(text) => {
                props.onChange(text, props.name);
              }}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;

      case "dateEnd":
        return (
          <>
            <DatePicker
              utcOffset={0}
              dateFormat="dd/MMMM/yyyy"
              timeFormat={"dd/MMMM/yyyy"}
              selected={new Date(value)}
              name={props.name}
              minDate={new Date(props.value["TanggalMulai"])}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              onChange={(text) => props.onChange(text, props.name)}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "tahun":
        return (
          <>
            <DatePicker
              utcOffset={0}
              showYearPicker
              dateFormat="yyyy"
              selected={new Date(value)}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white h-10"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500 h-10"
              }
              onChange={(text) => props.onChange(text, props.name)}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "bulan":
        return (
          <>
            <DatePicker
              utcOffset={0}
              dateFormat="MM/yyyy"
              showMonthYearPicker
              showFullMonthYearPicker
              selected={new Date(value)}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white h-10"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight outline-none bg-white border-gray-500 h-10"
              }
              onChange={(text) => props.onChange(text, props.name)}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "activity":
        if (activity.data) {
          return (
            <>
              <Select
                value={activity.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={activity.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "GetGoodsAcceptancePembayaran":
        if (GetGoodsAcceptancePembayaran.data) {
          let temparr = GetGoodsAcceptancePembayaran.data.data;

          temparr &&
            temparr.map(
              ({ GoodsAcceptanceID, Remarks, PurchaseOrderID }, id) => {
                temparr[id]["value"] = GoodsAcceptanceID;
                temparr[id][
                  "label"
                ] = `${PurchaseOrderID} - ${GoodsAcceptanceID} - ${Remarks}`;
              }
            );
          if (temparr)
            return (
              <>
                <Select
                  value={temparr.filter(
                    ({ value }) => value === props.value[props.name]
                  )}
                  name={props.name}
                  className={
                    (props.touched[props.name] || props.buttonTouched) &&
                    props.errors[props.name]
                      ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                  }
                  onChange={(text) => props.onChange(text)}
                  options={temparr}
                />

                {(props.touched[props.name] || props.buttonTouched) &&
                  props.touched[props.name] && (
                    <p className="text-red-500 text-xs italic">
                      {props.errors[props.name]}
                    </p>
                  )}
              </>
            );
        }
        break;

      case "GeneralServiceUnit":
        if (GeneralServiceUnit.data) {
          return (
            <>
              <Select
                value={GeneralServiceUnit.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={GeneralServiceUnit.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;

      case "Ac":
        if (penyakit.minData) {
          return (
            <>
              <Select
                value={penyakit.minData.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={penyakit.minData}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "Bagian":
        if (bagian.data) {
          // includeAll=true menambah opsi "All" (value "ALL"), pola sama spt BisnisUnit.
          const bagianOptionsSemua = props.includeAll
            ? [{ label: "All (Semua Bagian)", value: "ALL" }, ...bagian.data.data]
            : bagian.data.data;
          // onlyValues: batasi pilihan ke daftar BagianID tertentu (form MSR, user berhak pilih Bagian).
          const bagianOptions = props.onlyValues
            ? bagianOptionsSemua.filter(({ value }) => props.onlyValues.includes(value))
            : bagianOptionsSemua;
          return (
            <>
              <Select
                value={bagianOptions.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={bagianOptions}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "Bagianv2":
        if (bagian.data) {
          // Sama spt Bagianv3: salinan baru, jangan push ke hasil fetch.
          // Versi lama bahkan TANPA removeDuplicateValues, jadi "Tanpa Bagian"
          // benar-benar menumpuk tiap render. (Case ini tak dipakai di mana pun.)
          const tempbagian = removeDuplicateValues([
            ...bagian.data.data,
            { label: "Tanpa Bagian", value: "-" },
          ]);
          return (
            <>
              <Select
                value={tempbagian.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={tempbagian}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "Bagianv3":
        if (bagian.data) {
          if (bagian.data.data) {
            // Salinan BARU — jangan sentuh bagian.data.data. Dulu:
            // `tempbagian = bagian.data` (REFERENSI, bukan salinan) lalu
            // `tempbagian.data.push(...)` → memutasi hasil fetch SAAT RENDER,
            // menyisipkan "Tanpa Bagian" berulang tiap render, lalu ditambal
            // removeDuplicateValues (yg juga men-splice array yg sama).
            // Mutasi di dalam render bikin hasilnya bergantung pada berapa kali
            // komponen dirender — di StrictMode render jalan 2x. Sekarang array
            // opsi dibangun murni dari data, tanpa efek samping.
            const tempbagian = removeDuplicateValues([
              ...bagian.data.data,
              { label: "Tanpa Bagian", value: "" },
            ]);
            return (
              <>
                <Select
                  value={tempbagian.filter(
                    ({ value }) => value === props.value[props.name]
                  )}
                  name={props.name}
                  isDisabled={props.disabled}
                  className={
                    (props.touched[props.name] || props.buttonTouched) &&
                    props.errors[props.name]
                      ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                      : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                  }
                  onChange={(text) => props.onChange(text.value, props.name)}
                  options={tempbagian}
                />

                {(props.touched[props.name] || props.buttonTouched) &&
                  props.touched[props.name] && (
                    <p className="text-red-500 text-xs italic">
                      {props.errors[props.name]}
                    </p>
                  )}
              </>
            );
          }
        }
        break;
      case "BagianKodeJenis":
        if (bagian.data) {
          return (
            <>
              <Select
                value={bagian.data.data.filter(
                  ({ value, DetailAccountID }) =>
                    value === props.value[props.name] ||
                    (!props.value[props.name] &&
                      DetailAccountID &&
                      DetailAccountID === props.value["DetailAccountID"])
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) =>
                  props.onChange(text.value, props.name, text.DetailAccountID, text.label, text.LawanAccountID, text.LawanBebanAccountID)
                }
                options={bagian.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "Jabatan":
        if (jabatan.data) {
          // includeAll=true menambah opsi "All" (value "ALL"), pola sama spt BisnisUnit.
          const jabatanOptions = props.includeAll
            ? [{ label: "All (Semua Jabatan)", value: "ALL" }, ...jabatan.data.data]
            : jabatan.data.data;
          return (
            <>
              <Select
                value={jabatanOptions.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={jabatanOptions}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "PO":
        // if (po.data) {
        //     return (
        //         <>
        //             <Select
        //                 value={po.data.data.filter(
        //                     ({value}) => value===props.value[props.name]
        //                 )}
        //                 name={props.name}
        //                 className={
        //                     (props.touched[props.name] || props.buttonTouched) &&
        //                     props.errors[props.name]
        //                         ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
        //                         : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
        //                 }
        //                 onChange={(text) =>
        //                     po.onChange(text.value, props.name)
        //                 }
        //                 options={jabatan.data.data}
        //             />
        //
        //             {(props.touched[props.name] || props.buttonTouched) &&
        //                 props.touched[props.name] && (
        //                     <p className="text-red-500 text-xs italic">
        //                         {props.errors[props.name]}
        //                     </p>
        //                 )}
        //         </>
        //     )
        // }
        break;
      case "penyakit":
        if (penyakit.minData) {
          return (
            <>
              <Select
                value={penyakit.minData.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={penyakit.minData}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "KelompokKegiatan":
        if (KelompokKegiatan.data) {
          return (
            <>
              <Select
                value={KelompokKegiatan.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={KelompokKegiatan.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;

      case "Kelompok":
        if (kelompok.data) {
          let kelompokOptions = kelompok.data.data;
          if (props.bagianID && barang.data && barang.data.data) {
            const validKelompokIDs = new Set(
              barang.data.data
                .filter((b) => b.KodeJenisBarang === props.bagianID)
                .map((b) => b.KelompokID)
            );
            kelompokOptions = kelompok.data.data.filter(({ value }) =>
              validKelompokIDs.has(value)
            );
          }
          return (
            <>
              <Select
                value={kelompokOptions.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={kelompokOptions}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "Desa":
        if (Desa.data) {
          return (
            <>
              <Select
                value={Desa.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) =>
                  props.onChange(text.value, props.name, text.KepalaDesa)
                }
                options={Desa.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;

      case "DetailAccount":
        if (detailAccount.data) {
          return (
            <>
              <Select
                value={detailAccount.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                isDisabled={props.disabled}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => {
                  props.onChange(text.value, props.name);
                }}
                options={detailAccount.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "DetailAccountWithBody":
        if (detailAccount.data) {
          return (
            <>
              <Select
                value={detailAccount.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text)}
                options={detailAccount.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "LawanDetailAccount":
        if (detailAccount.data) {
          return (
            <>
              <Select
                isDisabled={true}
                value={detailAccount.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className="appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-gray-100 border-gray-500 rounded-lg"
                options={detailAccount.data.data}
              />
            </>
          );
        }
        break;
      case "LawanDetailAccountBeban":
        if (detailAccount.data) {
          return (
            <>
              <Select
                isDisabled={props.disabled}
                value={detailAccount.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={props.disabled
                  ? "appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-gray-100 border-gray-500 rounded-lg"
                  : "appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => {
                  props.onChange(text ? text.value : "", props.name);
                }}
                options={detailAccount.data.data}
              />
            </>
          );
        }
        break;
      case "DetailPembayaran":
        if (detailAccount.data && props.value["JenisCashJournal"]) {
          return (
            <>
              <Select
                value={detailAccount.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={detailAccount.data.data.filter(
                  ({ type }) => type === props.value["JenisCashJournal"]
                )}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;

      case "BisnisUnit": {
        if (bisnisUnit.data) {
          // includeAll=true menambah opsi "All" (value "ALL") → gabungan semua Bisnis Unit.
          const buOptions = props.includeAll
            ? [
                { label: "All (Semua Bisnis Unit)", value: "ALL" },
                ...bisnisUnit.data.data,
              ]
            : bisnisUnit.data.data;
          return (
            <>
              <Select
                value={buOptions.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={buOptions}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      }
      case "Satuan":
        if (satuan.data) {
          return (
            <>
              <Select
                value={satuan.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={satuan.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
      case "Kota":
        if (kota.data) {
          return (
            <>
              <Select
                value={kota.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={kota.data.data.filter(
                  ({ ProvinsiID }) => ProvinsiID === props.value["ProvinsiID"]
                )}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
      case "Provinsi":
        if (provinsi.data) {
          return (
            <>
              <Select
                value={provinsi.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={provinsi.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
      case "Negara":
        if (negara.data) {
          return (
            <>
              <Select
                value={negara.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={negara.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
      case "Barang":
        if (barang.data) {
          return (
            <>
              <Select
                value={barang.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={barang.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "BarangGoods":
        if (baranggoods.data) {
          return (
            <>
              <Select
                value={baranggoods.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={baranggoods.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "BarangAgregate":
        if (barang.data) {
          const stockMap = {};
          if (baranggoods.data && baranggoods.data.data) {
            baranggoods.data.data.forEach((s) => {
              stockMap[s.value] = parseFloat(s.StokTersedia) || 0;
            });
          }
          const barangBase = props.bagianID
            ? barang.data.data.filter(
                (b) => b.KodeJenisBarang === props.bagianID
              )
            : barang.data.data;
          const filteredOptions = barangBase.filter(
            ({ KelompokID }) => KelompokID === props.value["Kategory"]
          );
          const formatOptionLabel = (opt) => {
            const tersedia = stockMap[opt.value];
            const hasStock = tersedia !== undefined;
            const stockColor = !hasStock ? "#6b7280" : tersedia > 10 ? "#16a34a" : "#dc2626";
            return (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <span style={{ fontSize: "13px" }}>{opt.label}</span>
                {hasStock && (
                  <span style={{ fontSize: "12px", fontWeight: "600", color: stockColor, marginLeft: "8px", whiteSpace: "nowrap" }}>
                    Stok: {tersedia.toLocaleString()}
                  </span>
                )}
              </div>
            );
          };
          return (
            <>
              <Select
                value={barangBase.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={filteredOptions}
                formatOptionLabel={formatOptionLabel}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "JenisBarang":
        return (
          <>
            <Select
              value={JenisBarang.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={JenisBarang}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        break;
      case "KaryawanPemohon":
        if (karyawanPemohon.data) {
          return (
            <>
              <Select
                value={karyawanPemohon.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full text-gray-700 border border-red-500 outline-none bg-white"
                    : "appearance-none block w-full text-gray-700 border border-gray-200 outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={karyawanPemohon.data.data}
                isSearchable={true}
                placeholder="Cari nama pemohon..."
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "userPC":
        if (userPC.data) {
          return (
            <>
              <Select
                value={userPC.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={userPC.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;

      case "JenisPetugas":
        if (JenisPetugas.data) {
          return (
            <>
              <Select
                value={JenisPetugas.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={JenisPetugas.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }

        break;
      case "Menu":
        return (
          <>
            <Select
              value={Menu.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={Menu}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;

      case "Status":
        return (
          <>
            <Select
              value={Status.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={Status}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "PerkiraanHarga":
        return (
          <>
            <Select
              value={PerkiraanHarga.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              // selected={PerkiraanHarga.filter(
              //   (value) => value.value === "5100000"
              // )}
              onChange={(text) => {
                props.onChange(text.value, props.name);
              }}
              options={PerkiraanHarga}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "SatuanKendaraan":
        return (
          <>
            <Select
              value={SatuanKendaraan.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={SatuanKendaraan}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "JenisTransaksiKasBank":
        return (
          <>
            <Select
              value={JenisTransaksiKasBank.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={JenisTransaksiKasBank}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;

      // Varian form input form-kas-bank: opsi "Penerimaan" disembunyikan.
      case "JenisTransaksiKasBankInput":
        return (
          <>
            <Select
              value={JenisTransaksiKasBankInput.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={JenisTransaksiKasBankInput}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;

      case "TipePR":
        if (TipePR) {
          return (
            <>
              <Select
                value={TipePR.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                isDisabled={props.disabled}
                options={TipePR}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "Sifat":
        if (Sifat) {
          return (
            <>
              <Select
                value={Sifat.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                isDisabled={props.disabled}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={Sifat}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "JenisPenerimaan":
        if (TipePR) {
          return (
            <>
              <Select
                value={JenisPenerimaan.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                isDisabled={props.disabled}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => {
                  props.onChange(text.value, props.name);
                }}
                options={JenisPenerimaan}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;

      case "yesNot":
        return (
          <>
            <Select
              value={yesNot.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={yesNot}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "region":
        if (region.minData) {
          return (
            <>
              <Select
                value={region.minData.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={region.minData}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "file":
        return (
          <div className="flex flex-wrap -mx-3 mb-6">
            <div className=" px-3 mb-6 md:mb-0">
              <input
                type="file"
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "file:mr-4 file:py-2 file:px-4file:rounded-full file:border-0 file:text-sm file:font-semibold appearance-none block w-full  text-gray-700   outline-none bg-white"
                    : "file:mr-4 file:py-2 file:px-4file:rounded-full file:border-0 file:text-sm file:font-semibold appearance-none block w-full  text-gray-700   outline-none bg-white border-gray-500"
                }
                onChange={(e) => {
                  props.onChange(e.target.files[0], props.name);
                }}
              />
              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </div>
          </div>
        );
        break;
      case "cuti":
        if (cuti.minData) {
          return (
            <>
              <Select
                value={cuti.minData.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={cuti.minData}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "COA":
        if (COA.minData) {
          return (
            <>
              <Select
                value={COA.minData.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={COA.minData}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "mainAccount":
        if (mainAccount.data) {
          return (
            <>
              <Select
                value={mainAccount.data.data.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={mainAccount.data.data}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "karyawan":
        if (karyawan.minKaryawan) {
          return (
            <>
              <Select
                value={karyawan.minKaryawan.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  (props.touched[props.name] || props.buttonTouched) &&
                  props.errors[props.name]
                    ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                    : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) => props.onChange(text.value, props.name)}
                options={karyawan.minKaryawan}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        } else {
          return (
            <div className={"text-red-800"}>
              Golongan Karyawan Tidak Memiliki Jatah Cuti atau belum DiRegister
            </div>
          );
        }
        break;
      case "karyawanApproval":
        if (karyawan.minKaryawan) {
          return (
            <>
              <Select
                key={props.keys}
                value={karyawan.minKaryawan.filter(
                  ({ value }) => value === props.value[props.name]
                )}
                name={props.name}
                className={
                  "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                }
                onChange={(text) =>
                  props.onChange(text.value, props.name, props.idApproval)
                }
                options={karyawan.minKaryawan}
              />
              <a
                onClick={(e) => {
                  props.customHandlerApprovalDelete(props.idApproval);
                }}
                className={
                  "border text-white bg-main-100 hover:bg-white hover:border hover:border-main-100 hover:text-main-100 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none "
                }
              >
                {"Hapus"}
              </a>
            </>
          );
        }
        break;

      case "karyawanFull":
        return (
          <KaryawanSelectorCutiBuilder
            value={props.value["Nik"]}
            onChange={props.onChange}
            noTlpn={props.modifiers}
          />
        );
        break;
      case "Termin":
        // if (props.priceComparison.isSuccess) {
        return (
          <>
            <input
              value={parseInt(value)}
              name={props.name}
              disabled={props.disabled}
              className={
                props.errors[props.name]
                  ? "appearance-none w-6/12  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                  : "appearance-none w-6/12  text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white border-gray-500"
              }
              type="text"
            />
            {props.showNominal ? (
              <input
                value={parseFloat(PRListNominal).toLocaleString("in-ID", {
                  maximumFractionDigits: 2,
                })}
                name={`Total${props.name}`}
                disabled={props.disabled}
                title={
                  props.name === "Termin1" && terminBiayaLain.nominal > 0
                    ? "Sudah termasuk Biaya Lain-lain"
                    : undefined
                }
                className={
                  props.errors[props.name]
                    ? "appearance-none w-6/12  text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight outline-none bg-white"
                    : "appearance-none w-6/12  text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight outline-none bg-white border-gray-500"
                }
                type="text"
              />
            ) : null}
            {props.showNominal && props.name === "Termin1" && terminBiayaLain.nominal > 0 ? (
              <p className="text-xs text-blue-700 mt-1">
                Termin 1 sudah termasuk Biaya Lain-lain Rp{" "}
                {terminBiayaLain.nominal.toLocaleString("in-ID", { maximumFractionDigits: 0 })}
                {terminBiayaLain.ket ? ` (${terminBiayaLain.ket})` : ""} — di luar pajak.
              </p>
            ) : null}

            {props.isApproval && !props.checked ? (
              <label className="flex items-center gap-2 mt-2 cursor-pointer">
                <input
                  value={`1-${parseFloat(PRListNominal).toLocaleString("in-ID", {
                    maximumFractionDigits: 2,
                  })}`}
                  name={`CheckStatus${props.name}`}
                  type="checkbox"
                  onChange={props.onChange}
                />
                <span className="text-sm text-gray-700">Setujui termin ini</span>
              </label>
            ) : null}

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );
        // }
        break;
      case "Termin1":
        return (
          <>
            <Select
              value={JenisTermin.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => {
                props.onChange(props);
              }}
              onClick={onClickJenisTermin}
              options={JenisTermin}
            />
            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "StatusReportPO":
        return (
          <>
            <Select
              value={StatusReportPO.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              selected={StatusReportPO.filter((value) => value.value === "1")}
              onChange={(text) => {
                props.onChange(text.value, props.name);
              }}
              options={StatusReportPO}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "JenisBarangSatu":
        return (
          <>
            <Select
              value={JenisBarangSatu.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              selected={JenisBarangSatu.filter(
                (value) => value.value === "Material"
              )}
              onChange={(text) => {
                props.onChange(text.value, props.name);
              }}
              options={JenisBarangSatu}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "multipleSelect":
        if (karyawan.minKaryawan) {
          return (
            <>
              <Select
                isMulti
                // value={JSON.parse(props.currentData.Cc)}
                // defaultValue={JSON.parse(props.currentData.Cc)}
                name={props.name}
                // className={
                //   (props.touched[props.name] || props.buttonTouched) &&
                //   props.errors[props.name]
                //     ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                //     : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
                // }
                onChange={(e) => {
                  let value = [...e].map((opt) => opt.value);
                  props.onChange(value, props.name);
                }}
                options={karyawan.minKaryawan}
              />

              {(props.touched[props.name] || props.buttonTouched) &&
                props.touched[props.name] && (
                  <p className="text-red-500 text-xs italic">
                    {props.errors[props.name]}
                  </p>
                )}
            </>
          );
        }
        break;
      case "MemoStatus":
        return (
          <>
            <Select
              value={MemoStatus.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              onChange={(text) => props.onChange(text.value, props.name)}
              options={MemoStatus}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
      case "LokasiGudang":
        return (
          <>
            <Select
              value={LokasiGudang.filter(
                ({ value }) => value === props.value[props.name]
              )}
              name={props.name}
              className={
                (props.touched[props.name] || props.buttonTouched) &&
                props.errors[props.name]
                  ? "appearance-none block w-full  text-gray-700 border border-red-500  outline-none bg-white"
                  : "appearance-none block w-full  text-gray-700 border border-gray-200  outline-none bg-white border-gray-500 rounded-lg"
              }
              selected={LokasiGudang.filter((value) => value.value === "1")}
              onChange={(text) => {
                props.onChange(text.value, props.name);
              }}
              options={LokasiGudang}
            />

            {(props.touched[props.name] || props.buttonTouched) &&
              props.touched[props.name] && (
                <p className="text-red-500 text-xs italic">
                  {props.errors[props.name]}
                </p>
              )}
          </>
        );

        break;
    }
  };

  return (
    <div
      className={
        props.size !== "full" ? "w-full md:w-1/2 px-3" : "w-full px-3 mb-6"
      }
    >
      <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
        {props.title} {props.required ? "*" : ""}
      </label>
      {renderSwitch()}
    </div>
  );
}
